class Impact {
  constructor({ title, subtitle, _id }) {
    this.id = _id;
    this.title = title;
    this.subtitle = subtitle;
  }
}

export default Impact;
